import React, { useEffect, useState } from 'react';
import Switch from '../../Switch';
import Form, { useForm } from '../../../molecules/Form';
import Field from '../../Field';
import Button from '../../../molecules/Button';
import { StyledTabSetComponents } from '../TabSetComponents.styles';

const InvoiceNumber = ({ title, data, deviceId, completeData, onSubmit }) => {
  const [form] = useForm();
  const [increment, setIncrement] = useState(null);
  const handelTerminalLang = e => {
    const { name } = e.target;
    setIncrement(name);
  };

  const handleSubmit = async e => {
    const payload = {
      id: deviceId,
      configuration: {
        ...completeData?.configuration,
        transaction_settings: {
          ...completeData?.configuration?.transaction_settings,
          invoice_number: {
            _l: e?.Lock,
            _v: e?.visible,
            auto_increment: {
              value: increment === 'autoIncrement',
            },
            manual_entry: {
              value: increment === 'manualIncrement',
            },
          },
        },
      },
    };

    onSubmit(payload);
  };

  useEffect(() => {
    form.setFieldsValue({
      visible: data?._v,
      Lock: data?._l,
    });
    if (data?.auto_increment?.value) {
      setIncrement('autoIncrement');
    } else {
      setIncrement('manualIncrement');
    }
  }, [data, form]);
  return (
    <StyledTabSetComponents form={form} onSubmit={handleSubmit}>
      <div className="tab-body-header">
        <strong className="title">{title}</strong>
        <div className="switch-wrap">
          <Form.Item label="Visible" name="visible">
            <Switch />
          </Form.Item>
          <Form.Item label="Lock" name="Lock">
            <Switch label="Lock" />
          </Form.Item>
        </div>
      </div>
      <div className="tab-body-body">
        <div className="terminal-switch">
          <div className="terminal-switch-wrap">
            <Form.Item
              labelIcon
              radioBorder="#F1F1F1"
              label="Auto Increment"
              name="autoIncrement"
              type="radio"
              onChange={handelTerminalLang}
              value={increment === 'autoIncrement'}>
              <Field />
            </Form.Item>
            <Form.Item
              labelIcon
              radioBorder="#F1F1F1"
              label="Manual Increment"
              name="manualIncrement"
              type="radio"
              onChange={handelTerminalLang}
              value={increment === 'manualIncrement'}>
              <Field />
            </Form.Item>
          </div>
        </div>
      </div>
      <div className="submission-wrapper">
        <Button width="140px">Confirm</Button>
      </div>
    </StyledTabSetComponents>
  );
};

export default InvoiceNumber;
